import React from "react";

function Headlins({ title, suptitle }) {
  return (
    <div className="headlines">
      <p>{suptitle}</p>
      <h3>{title}</h3>
    </div>
  );
}

export default Headlins;
